import Cookies from "js-cookie";

const domain =
	window.location.hostname == "admin.foljeton.dev"
		? ".foljeton.dev"
		: ".foljeton.dk";
const BASE_URL = "https://central-api.foljeton.dk";
//const BASE_URL = "http://localhost:8080";
const cookies = Cookies.withAttributes({
	domain: domain,
});
let rawUserData = cookies.get("flj-user");
if (!rawUserData && isStandalone()) {
	rawUserData = localStorage.getItem("flj-user");
}
console.log("stand-alone", isStandalone());
console.log("rud", rawUserData);
const userData = rawUserData ? JSON.parse(rawUserData) : null;
console.log("ud", userData);
let box;
let copy;

function getArticleState() {
	return window.foljeton.status;
}

function init() {
	const articleState = getArticleState();

	if (articleState === "free") {
		return;
	}
	if (articleState === "user") {
		handleUserArticle();
	}
	if (articleState === "subscription") {
		handleSubscriptionArticle();
	}
}
function showUserBox() {
	box = buildBox();

	copy = document.createElement("div");
	copy.classList.add("flj-paywall-copy");
	copy.innerHTML = `
        <h2>Vil du have artiklen gratis?</h2>
        <p>Vi låser den straks op, hvis du opretter en bruger på Føljeton – og skriver dig op til vores gratis nyhedsbrev.</p>
    `;
	box.appendChild(copy);

	const userForm = buildUserForm();

	box.appendChild(userForm);

	const loginForm = buildLoginLink();

	box.appendChild(loginForm);
}
function showSubscriptionBox() {
	box = buildBox();

	copy = document.createElement("div");
	copy.classList.add("flj-paywall-copy");
	copy.innerHTML = `
        <h2>Vil du have artiklen gratis?</h2>
        <p>Vi låser den op med det samme, hvis du tegner et prøveabonnement på Føljeton. Det koster 0 kr. Ingen binding.</p>
    `;
	box.appendChild(copy);

	const button = document.createElement("input");
	button.type = "submit";
	button.value = "Ja tak!";
	button.addEventListener("click", (evt) => {
		evt.preventDefault();
		const url =
			"https://din.foljeton.dk/opret-bruger?redirect=article&url=" +
			window.location.href;
		window.location.href = url;
	});

	const form = document.createElement("form");
	form.appendChild(button);

	box.appendChild(form);

	const loginForm = buildLoginLink();

	box.appendChild(loginForm);
}
function showLoginBox() {
	if (!box) {
		box = buildBox();
	}
	box.innerText = "";

	/* copy = document.createElement("div");
    copy.classList.add("flj-paywall-copy");
    copy.innerHTML = `
        <h2>Vil du have artiklen gratis?</h2>
        <p>Vi låser den straks op, hvis du opretter en bruger på Føljeton – og skriver dig op til vores gratis nyhedsbrev.</p>
    `
    box.appendChild(copy) */

	const loginForm = buildLoginForm();

	box.appendChild(loginForm);

	/*const loginForm = buildLoginLink();

    box.appendChild(loginForm)*/
}
function buildLoginLink() {
	const wrapper = document.createElement("div");
	wrapper.classList.add("flj-paywall-login-link");

	const copy = document.createElement("span");
	copy.classList.add("flj-paywall-login-link-copy");
	copy.innerText = "Allerede abonnent? ";

	wrapper.appendChild(copy);

	const link = document.createElement("a");
	link.classList.add("flj-paywall-login-link-copy");
	link.innerText = "Log ind";
	link.href = "#";
	link.addEventListener("click", (e) => {
		e.preventDefault();
		showLoginBox();
	});

	wrapper.appendChild(link);

	return wrapper;
}
function buildUserForm() {
	const form = document.createElement("form");

	const mail = document.createElement("input");
	mail.type = "email";
	mail.required = true;
	mail.placeholder = "Skriv din mailadresse";

	form.appendChild(mail);

	const password = document.createElement("input");
	password.type = "password";
	password.required = true;
	password.minLength = 6;
	password.placeholder = "Vælg et kodeord";

	form.appendChild(password);

	const feedback = document.createElement("div");
	feedback.classList.add("feedback");
	form.appendChild(feedback);

	const button = document.createElement("input");
	button.type = "submit";
	button.value = "Fortsæt";
	button.addEventListener("click", (event) => {
		event.preventDefault();
		const validity = validateUser(mail, password);
		if (validity.valid) {
			// Send request
			const userObject = {
				email: mail.value,
				password: password.value,
				name: "Gæst",
			};
			fetch(BASE_URL + "/user/register", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(userObject),
			})
				.then((resp) =>
					resp
						.json()
						.then((data) => ({ status: resp.status, body: data }))
				)

				.then((obj) => {
					if (obj.status === 200) {
						// DO shit
						console.log(obj);
						cookies.set("flj-user", JSON.stringify(obj.body));
						enter();
					} else if (obj.status === 409) {
						displayValidityFeedback(
							{
								valid: false,
								messages: ["Brugeren findes allerede"],
							},
							feedback
						);
					}
				});
		} else {
			displayValidityFeedback(validity, feedback);
		}
	});

	form.appendChild(button);

	return form;
}
function displayValidityFeedback(validity, feedback) {
	let string = "";
	validity.messages.forEach((msg) => {
		string += `<li>${msg}</li>`;
	});
	if (string) {
		feedback.innerHTML = `<ul>${string}</ul>`;
	}
}
function validateUser(mail, password) {
	const validity = {
		valid: true,
		messages: [],
	};

	if (!mail.validity.valid) {
		validity.valid = false;
		if (mail.validity.valueMissing) {
			validity.messages.push("Du mangler at angive en email");
		} else {
			validity.messages.push("Din email er vist ikke korrekt");
		}
	}
	if (!password.validity.valid) {
		validity.valid = false;
		if (password.validity.valueMissing) {
			validity.messages.push("Du mangler at angive et kodeord");
		} else {
			validity.messages.push(
				"Dit kodeord er lidt kort. Prøv med min. 6 tegn."
			);
		}
	}
	return validity;
}

function buildLoginForm() {
	const form = document.createElement("form");

	const mail = document.createElement("input");
	mail.type = "email";
	mail.placeholder = "Skriv din mailadresse";
	mail.required = true;

	form.appendChild(mail);

	const password = document.createElement("input");
	password.type = "password";
	password.placeholder = "Skriv kodeord";
	password.required = true;

	form.appendChild(password);

	const feedback = document.createElement("div");
	feedback.classList.add("feedback");
	form.appendChild(feedback);

	const button = document.createElement("input");
	button.type = "submit";
	button.value = "Log ind";

	button.addEventListener("click", (evt) => {
		evt.preventDefault();
		console.log("click");

		const validity = validateUser(mail, password);
		console.log(validity);
		if (!validity.valid) {
			displayValidityFeedback(validity, feedback);
		}
		const user = {
			email: mail.value,
			password: password.value,
		};
		fetch(BASE_URL + "/user/login", {
			method: "POST", // *GET, POST, PUT, DELETE, etc.
			mode: "cors", // no-cors, *cors, same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				"Content-Type": "application/json",
			},
			redirect: "follow", // manual, *follow, error
			referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
			body: JSON.stringify(user), // body data type must match "Content-Type" header
		})
			.then((resp) => {
				console.log(resp);
				if (resp.status !== 200) {
					feedback.innerHTML = `
						<ul><li>Kunne ikke finde en bruger med den mail og det kodeord</li></ul>
					`;
					return;
				}
				return resp.json();
			})
			.then((data) => {
				if (data) {
					storeUserData(data);
					enter();
					console.log(data);
				} else {
					console.log("fail");
					console.log(data);
					feedback.innerHTML = `
						<ul><li>Kunne ikke finde en bruger med den mail og det kodeord</li></ul>
					`;
				}
			})
			.catch((err) => {
				console.log(err);
			});
	});
	form.appendChild(button);

	const link = document.createElement("a");
	link.classList.add("flj-paywall-forgot-link");
	link.innerText = "Glemt password?";
	link.href = "https://din.foljeton.dk/glemt";

	form.appendChild(link);

	return form;
}
function storeUserData(user) {
	cookies.set("flj-user", JSON.stringify(user));
	if (isStandalone()) {
		localStorage.setItem("flj-user", JSON.stringify(user));
	}
	console.log("just set", localStorage.getItem("flj-user"));
}
function handleUserArticle() {
	if (!userData) {
		showUserBox();
	} else {
		return;
	}
}

function handleSubscriptionArticle() {
	console.log(userData);

	if (!userData) {
		showSubscriptionBox();
	} else if (userData.fljState != "active") {
		console.log(userData.fljState, userData.fljState != "active");
		if (userData.customer_id) {
			const headers = new Headers({
				Authorization: "Bearer " + userData.token,
			});
			fetch(BASE_URL + "/customer/" + userData.customer_id, {
				headers: headers,
			})
				.then((data) => data.json())
				.then((data) => {
					if (
						!data ||
						!data.customer ||
						!data.customer.invoice_settings ||
						!data.customer.invoice_settings.default_payment_method
					) {
						return false;
					}
					return fetch(
						BASE_URL +
							"/customer/" +
							userData.customer_id +
							"/payment-method/" +
							data.customer.invoice_settings
								.default_payment_method,
						{
							headers: headers,
						}
					);
				})
				.then((data) => {
					if (!data) {
						return false;
					}
					return data.json();
				})
				.then((data) => {
					if (!data) {
						showSubscriptionBox();
					}
					// Has card
					return;
				});
		}
	} else {
		return;
	}
}

function buildBox() {
	box = document.createElement("div");
	box.classList.add("flj-paywall-box");

	const inner = document.createElement("div");
	inner.classList.add("flj-inner-paywall-box");
	box.appendChild(inner);

	document.body.appendChild(box);

	document.body.classList.add("fjl-paywall");

	return inner;
}
function enter() {
	box.innerHTML = `
		<h2>Velkommen!</h2>
		<p>Du har nu adgang</p>
	`;

	const button = document.createElement("input");
	button.type = "submit";
	button.value = "Vis artiklen";
	button.addEventListener("click", () => {
		hideWall();
	});
	setTimeout(() => {
		hideWall();
	}, 3000);
	const form = document.createElement("form");
	form.appendChild(button);

	box.appendChild(form);
}
function hideWall() {
	document.body.classList.remove("fjl-paywall");
	box.remove();
}
function isStandalone() {
	return (
		window.matchMedia("(display-mode: standalone)").matches ||
		window.navigator.standalone
	);
}

init();
